// pt_did is the visitor's PostHog distinct id, which the API sets as a server cookie on profittree.io so it outlives
// PostHog's own storage. PostHog boots from it, and the funnel asks the API to set it when it is missing.
// The base URL may come with or without a trailing slash, so the path joins it the way the API request service does.
import { ApiBaseUrl } from "../../config"
import { readCookie } from "./read-cookie"

const IDENTITY_COOKIE = "pt_did"

export const readIdentityCookie = (): string | undefined => readCookie(IDENTITY_COOKIE)

export const ensureIdentityCookie = async (distinctId: string): Promise<void> => {
  try {
    await fetch(`${ApiBaseUrl.replace(/\/+$/, "")}/identity`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ distinct_id: distinctId }),
    })
  } catch (error) {
    console.error("Failed to set the identity cookie:", error)
  }
}
